var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgehubKusama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10211_25681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.165C15.0617 19.165 19.165 15.0617 19.165 9.99996C19.165 4.93827 15.0617 0.834961 9.99996 0.834961C4.93827 0.834961 0.834961 4.93827 0.834961 9.99996C0.834961 15.0617 4.93827 19.165 9.99996 19.165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2644 9.82239C12.2867 9.81076 12.3084 9.79879 12.3297 9.78647C12.6033 9.62778 12.803 9.43352 12.9288 9.2037C13.0547 8.9684 13.1176 8.70848 13.1176 8.42394C13.1176 7.95335 12.9562 7.58672 12.6334 7.32407C12.3105 7.05594 11.8645 6.92188 11.2954 6.92188H6.6333L7.10116 9.9178L6.6333 13.0779H11.4678C12.1354 13.0779 12.6443 12.9165 12.9945 12.5936C13.3502 12.2653 13.528 11.8385 13.528 11.3132C13.528 10.8261 13.3502 10.4431 12.9945 10.164C12.8007 10.012 12.5573 9.89809 12.2644 9.82239ZM11.2216 11.5348C11.1176 11.6278 10.9753 11.6743 10.7948 11.6743H8.84804L9.01345 10.6073H10.7783C10.9699 10.6073 11.1176 10.6593 11.2216 10.7632C11.3255 10.8617 11.3775 10.9876 11.3775 11.1408C11.3775 11.3049 11.3255 11.4363 11.2216 11.5348ZM9.00653 9.22832H10.4664C10.6087 9.22832 10.7264 9.18455 10.8194 9.097C10.9179 9.00944 10.9671 8.89727 10.9671 8.76047C10.9671 8.62914 10.9206 8.52517 10.8276 8.44856C10.74 8.36648 10.6197 8.32544 10.4664 8.32544H8.85751L9.00653 9.22832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4175 3.7007C11.4175 4.48357 10.7829 5.1182 10 5.1182C9.21716 5.1182 8.58252 4.48357 8.58252 3.7007C8.58252 2.91784 9.21716 2.2832 10 2.2832C10.7829 2.2832 11.4175 2.91784 11.4175 3.7007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4175 16.3007C11.4175 17.0836 10.7829 17.7182 10 17.7182C9.21716 17.7182 8.58252 17.0836 8.58252 16.3007C8.58252 15.5178 9.21716 14.8832 10 14.8832C10.7829 14.8832 11.4175 15.5178 11.4175 16.3007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1646 8.0787C15.4867 8.47014 14.6197 8.23784 14.2283 7.55986C13.8369 6.88188 14.0692 6.01495 14.7471 5.62352C15.4251 5.23209 16.292 5.46438 16.6835 6.14236C17.0749 6.82034 16.8426 7.68727 16.1646 8.0787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25271 14.3787C4.57473 14.7701 3.7078 14.5378 3.31637 13.8599C2.92494 13.1819 3.15723 12.315 3.83521 11.9235C4.51319 11.5321 5.38012 11.7644 5.77155 12.4424C6.16298 13.1203 5.93069 13.9873 5.25271 14.3787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83521 8.0787C4.51319 8.47013 5.38012 8.23784 5.77155 7.55986C6.16298 6.88188 5.93069 6.01495 5.25271 5.62352C4.57473 5.23208 3.7078 5.46438 3.31637 6.14236C2.92493 6.82034 3.15723 7.68727 3.83521 8.0787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7471 14.3787C15.4251 14.7701 16.292 14.5378 16.6835 13.8599C17.0749 13.1819 16.8426 12.3149 16.1646 11.9235C15.4866 11.5321 14.6197 11.7644 14.2283 12.4424C13.8369 13.1203 14.0691 13.9873 14.7471 14.3787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10211_25681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgehubKusama);
export default __webpack_public_path__ + "static/media/bridgehub-kusama.73f03c9608373973347644d3a7bc2446.svg";
export { ForwardRef as ReactComponent };